module.exports = __webpack_public_path__ + "static/OK-51448e838ba36d1dab88d32b3d5bc3f0.png";